import { render, staticRenderFns } from "./EmployeeSalaryDefault.vue?vue&type=template&id=5a819b68&scoped=true"
import script from "./EmployeeSalaryDefault.vue?vue&type=script&lang=js"
export * from "./EmployeeSalaryDefault.vue?vue&type=script&lang=js"
import style0 from "./EmployeeSalaryDefault.vue?vue&type=style&index=0&id=5a819b68&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a819b68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a819b68')) {
      api.createRecord('5a819b68', component.options)
    } else {
      api.reload('5a819b68', component.options)
    }
    module.hot.accept("./EmployeeSalaryDefault.vue?vue&type=template&id=5a819b68&scoped=true", function () {
      api.rerender('5a819b68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employeeSalary/EmployeeSalaryDefault.vue"
export default component.exports